import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=435618fe&scoped=true&"
import script from "./PostDetail.vue?vue&type=script&lang=js&"
export * from "./PostDetail.vue?vue&type=script&lang=js&"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=435618fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435618fe",
  null
  
)

export default component.exports